var _defs, _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4, _circle5, _path5, _circle6, _path6, _circle7, _path7, _circle8, _path8, _circle9, _path9, _circle10, _path10, _path11, _circle11, _path12, _path13, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamePieceDaisy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80mm",
    height: "80mm",
    viewBox: "0 0 226.7717 226.7717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00e1ff;}.b{fill:#001959;}.c{fill:#ffdb06;}.d{fill:#ff7300;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 113.8128,
    cy: 46.9513,
    r: 28.955,
    transform: "translate(49.2369 151.7737) rotate(-80.7825)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.812,78.3251a31.3739,31.3739,0,1,1,31.3746-31.3743A31.4089,31.4089,0,0,1,113.812,78.3251Zm0-57.91a26.5365,26.5365,0,1,0,26.5371,26.536A26.5662,26.5662,0,0,0,113.812,20.4148Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.0208,
    cy: 66.7473,
    r: 28.955
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.0216,98.1211a31.3745,31.3745,0,1,1,22.184-9.1906A31.162,31.162,0,0,1,66.0216,98.1211Zm0-57.8974a26.5229,26.5229,0,1,0,18.7637,7.7591A26.4543,26.4543,0,0,0,66.0216,40.2237Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 46.2248,
    cy: 114.5393,
    r: 28.955,
    transform: "translate(-40.3136 26.4082) rotate(-22.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.2256,145.9139A31.3745,31.3745,0,1,1,77.5978,114.54,31.4109,31.4109,0,0,1,46.2256,145.9139Zm0-57.9116A26.5372,26.5372,0,1,0,72.76,114.54,26.5672,26.5672,0,0,0,46.2256,88.0023Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.0208,
    cy: 162.3313,
    r: 28.9549
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.0216,193.69a31.3591,31.3591,0,1,1,22.184-9.1739A31.2784,31.2784,0,0,1,66.0216,193.69Zm0-57.8833a26.5243,26.5243,0,1,0,18.7637,7.7594A26.4533,26.4533,0,0,0,66.0216,135.8069Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 113.8128,
    cy: 182.1274,
    r: 28.955
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.812,213.5a31.3733,31.3733,0,1,1,31.3746-31.3719A31.4068,31.4068,0,0,1,113.812,213.5Zm0-57.9092a26.536,26.536,0,1,0,26.5371,26.5373A26.5666,26.5666,0,0,0,113.812,155.5911Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 161.6048,
    cy: 162.3313,
    r: 28.9549
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M161.6048,193.69a31.2784,31.2784,0,0,1-22.184-9.1739h0a31.4092,31.4092,0,1,1,22.184,9.1739Zm-18.7637-12.5941a26.5367,26.5367,0,1,0,0-37.53,26.5676,26.5676,0,0,0,0,37.53Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 181.4008,
    cy: 114.5393,
    r: 28.955
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M181.4008,145.9139A31.3745,31.3745,0,1,1,212.7754,114.54,31.4109,31.4109,0,0,1,181.4008,145.9139Zm0-57.9116a26.5372,26.5372,0,1,0,26.537,26.5372A26.5674,26.5674,0,0,0,181.4008,88.0023Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 161.6048,
    cy: 66.7473,
    r: 28.955
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M161.6048,98.1211a31.3745,31.3745,0,1,1,22.184-9.1906h0A31.1625,31.1625,0,0,1,161.6048,98.1211Zm0-57.8974A26.53,26.53,0,1,0,180.3685,85.51h0a26.5229,26.5229,0,0,0-18.7637-45.2866Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 113.8128,
    cy: 114.5393,
    r: 66.4214,
    transform: "translate(-47.6565 114.0256) rotate(-45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.812,183.38a68.8406,68.8406,0,1,1,68.8407-68.84A68.9168,68.9168,0,0,1,113.812,183.38Zm0-132.8438A64.0033,64.0033,0,1,0,177.8151,114.54,64.0746,64.0746,0,0,0,113.812,50.5362Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 135.8103,
    cy: 116.1142,
    r: 2.6788
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.8092,121.2122a5.0973,5.0973,0,1,1,5.0974-5.0972A5.1028,5.1028,0,0,1,135.8092,121.2122Zm0-5.357a.259.259,0,0,0-.26.26c0,.2882.52.2882.52,0A.2562.2562,0,0,0,135.8092,115.8552Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.812,142.5292a12.8063,12.8063,0,0,1-12.79-12.7925,2.4188,2.4188,0,1,1,4.8375,0,7.954,7.954,0,1,0,15.908,0,2.4187,2.4187,0,1,1,4.8373,0A12.8082,12.8082,0,0,1,113.812,142.5292Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 150.4833,
    cy: 131.5327,
    r: 7.4568,
    transform: "translate(-12.1047 247.7705) rotate(-76.7175)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M89.1366,116.1142a2.6788,2.6788,0,1,0,2.6787-2.6788A2.6787,2.6787,0,0,0,89.1366,116.1142Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M91.8146,121.2122a5.0973,5.0973,0,1,1,5.0973-5.0972A5.1026,5.1026,0,0,1,91.8146,121.2122Zm0-5.357a.259.259,0,0,0-.26.26c0,.2882.52.2882.52,0A.2563.2563,0,0,0,91.8146,115.8552Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 77.1423,
    cy: 131.5327,
    r: 7.4567,
    transform: "translate(-28.1563 21.2422) rotate(-13.2825)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePieceDaisy);
export default __webpack_public_path__ + "static/media/GamePiece - Daisy.4bc58d07f7f77a882655348cb48d28b8.svg";
export { ForwardRef as ReactComponent };